import { bankIFSCValidation, required } from '@jfs/ui-new'
import { notRequired } from '@jfs/ui-new/src/utils/validations'
import { useEffect } from 'react'
import { Dropdown } from '../../../../components/Dropdown'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { IFSCEditText } from '../comps/IFSCEditText'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { UploadEntityFile } from '../comps/UploadEntityFile'
import { DocTypeDropdown } from './documentUploadForm'
import { allowParentIdSettlement, getBankDocCategory, getDropdownData } from './dropdownData'
import { styles } from './styles'
import { accountNoValidation, confirmAccountNoValidation, hideNonExistantFields, Name } from './validations'

export const bankDetailsForm = (dropDownData: any, editable: boolean, isStoreMerchant: boolean) => ({
  key: 'BANK_DETAILS_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'Bank Details',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'bankAccountHolderName',
          ComponentName: TextInputWithInfo,
          label: 'Bank A/C Holder Name',
          placeholder: 'Bank A/C Holder Name',
          validationSchema: Name,
          ...styles.textinputStyle(editable),
          testID: 'bankAccountHolderName',
        },
        {
          fieldName: 'settlementAccountNumber',
          ComponentName: TextInputWithInfo,
          label: 'Settlement A/C No',
          placeholder: 'Settlement A/C No',
          validationSchema: accountNoValidation,
          ...styles.textinputStyle(editable),
          testID: 'settlementAccountNumber',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'confirmSettlementAccountNumber',
          ComponentName: TextInputWithInfo,
          fieldToValidate: 'settlementAccountNumber',
          label: 'Confirm Settlement A/C No',
          placeholder: 'Confirm Settlement A/C No',
          hide: !editable,
          validationSchema: confirmAccountNoValidation,
          ...styles.textinputStyle(editable),
          testID: 'confirmSettlementAccountNumber',
        },
        {
          fieldName: 'ifscCode',
          ComponentName: IFSCEditText,
          label: 'IFSC Code',
          placeholder: 'IFSC Code',
          editable: editable,
          validationSchema: bankIFSCValidation,
          ...styles.textinputStyle(editable),
          testID: 'ifscCode',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'bankName',
          ComponentName: TextInputWithInfo,
          label: 'Bank Name',
          hideComponent: hideNonExistantFields('bankName'),
          editable: false,
          ...styles.textinputStyle(false),
          testID: 'bankName',
        },
        {
          fieldName: 'branchName',
          ComponentName: TextInputWithInfo,
          label: 'Bank Branch',
          hideComponent: hideNonExistantFields('branchName'),
          editable: false,
          ...styles.textinputStyle(false),
          testID: 'branchName',
        },
      ],
      horizontalSpacing: 8,
    },

    {
      fieldName: 'canceled_check',
      ComponentName: UploadEntityFile,
      isOptional: isStoreMerchant,
      uploadButtonTitle: 'Upload Bank Documents',
      uploadDialogTitle: 'Upload Required Doc',
      nonEditableTitle: 'Uploaded Bank Documents',
      jdmsTableColumns: ['Document Category', 'Document Id', 'Action'],
      hideColumnsJdms: ['kycDocuments', 'dateOfExpiry', 'documentNumber', 'MERCHANT_DOCUMENT_TYPE'],
      uploadId: dropDownData?.uploadId,
      editable,
      acceptMultiple: true,
      documentListHeaderMapper: [
        {
          key: 'MERCHANT_DOCUMENT_TYPE',
          header: 'Document Category',
        },
        {
          key: 'NAME',
          header: 'File Name',
        },
        {
          key: 'MERCHANT_DOCUMENT_NAME',
          header: 'Doc Type',
        },
        {
          key: 'expiry',
          header: 'Expiry Date',
        },
        {
          key: 'documentNumber',
          header: 'Doc Id',
        },
        {
          key: '',
          header: '',
        },
      ],
      uploadFileReqMapper: {
        documentName: 'bankDocType',
        documentCategory: 'bankDocCategory',
        documentType: 'bankDocType',
      },
      uploadFileReqConstants: {
        uploadType: 'ENTITY',
      },
      documentCategoriesSupported: ['CC', 'FS'],
      categoryFieldName: 'bankDocCategory',
      rowData: [
        {
          fieldName: 'bankDocCategory',
          ComponentName: Dropdown,
          label: 'Doc category',
          title: 'Select document type',
          data: [
            { id: 1, value: 'Cancelled cheque' },
            { id: 1, value: 'Financial document' },
          ],
          minHeight: 32,
          fullWidthContent: true,
          labelType: 'label',
          testID: 'authSignatoryPoiType',
        },
        {
          fieldName: 'bankDocType',
          ComponentName: DocTypeDropdown,
          label: 'Doc Type',
          labelType: 'label',
          docCategoryFieldName: 'bankDocCategory',
          minHeight: 32,
          validationSchema: required,
          title: 'Select document type',
          documentCategoryList: getBankDocCategory(dropDownData?.lovData, 'DocumentCategory'),

          fullWidthContent: true,
          testID: 'authSignatoryPoiType',
        },
      ],
      docCategoryLov: getBankDocCategory(dropDownData?.lovData, 'DocumentCategory'),
      testID: 'authSignatoryPoi',
    },
    {
      horizontalComps: [
        {
          fieldName: 'settlementDetailsTitle',
          ComponentName: TitleWithDashedLine,
          title: 'Settlement Details',
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'settlementFrequency',
          ComponentName: DropdownWithInfo,
          label: 'Settlement Frequency',
          data: getDropdownData(dropDownData?.lovData, 'SettlementFrequencyESS'),
          dataFieldToRead: 'description',
          title: 'Select Settlement Frequency',
          validationSchema: isStoreMerchant ? notRequired : required,
          ...styles.dropDownStyle(editable),
          testID: 'settlementFrequency',
        },
        {
          fieldName: 'settlementPlanId',
          ComponentName: SettlementPlanIdText,
          label: 'Settlement Plan Id',
          data: getDropdownData(dropDownData?.lovData, 'SettlementFrequencyESS'),
          placeholder: 'Settlement Plan Id',
          ...styles.textinputStyle(editable),
          testID: 'settlementPlanId',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'allowParentIdSettlement',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: required,
          label: 'Allow ParentId Settlement',
          data: allowParentIdSettlement,
          defaultEditableValue: 'No',
        },
      ],
      horizontalSpacing: 8,
    },
  ],
  onSubmit: async (values) => {},
})

const SettlementPlanIdText = (props: any) => {
  const settlementFrequencyText = props?.allValues?.settlementFrequency
  const settlementFrequencyValue = props?.data?.find((item) => item?.description == settlementFrequencyText)?.value
  useEffect(() => {
    props?.setFieldValue(props.fieldName, settlementFrequencyValue)
  }, [settlementFrequencyValue])
  return <TextInputWithInfo {...props} value={settlementFrequencyValue} />
}
